import { Popconfirm } from "antd";
import { BsDot } from "react-icons/bs";
import { MdDelete } from "react-icons/md";
import { GetDropDownApi } from "./CommonApis";

export const download = (data, filename) => {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(data);
  link.download = filename;
  link.click();
};

export const downloadExcel = (blob) => {
//   const data = Uint8Array.from(atob(blob), c => c.charCodeAt(0))
  const data = blob.arrayBuffer()
  console.log(data)
  const file = new Blob([data], { type: "application/vnd.ms-excel" });
  const url = URL.createObjectURL(file);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "hjh";
  anchor.click();
  anchor.remove();
};

export const createPolicyMenuItems = (data, handleDelete, isAdmin) => {
  let prevDept = data[0]?.department || "";
  let children = [];

  let policyItems = [];

  data.map((val, i, arr) => {
    if (val.department !== prevDept) {
      policyItems.push({ label: prevDept, key: prevDept, children: children });
      children = [];
      prevDept = val.department;
    }
    isAdmin
      ? children.push({
          label: (
            <span>
              <BsDot className="fs-1 pb-1" /> {val.name}
            </span>
          ),
          key: val.name,
          url: val.file_uri.replace(
            "https://blobstoragefors3bucket.blob.core.windows.net",
            ""
          ),
          icon: (
            <Popconfirm
              title={`Are you sure to delete ${val.name}?`}
              onConfirm={() => handleDelete(val._id, val.name)}
              okText="Yes"
              cancelText="No"
            >
              <div className="nav-menu-icon-danger">
                <MdDelete />
              </div>
            </Popconfirm>
          ),
        })
      : children.push({
          label: (
            <span>
              <BsDot className="fs-1 pb-1" /> {val.name}
            </span>
          ),
          key: val.name,
          url: val.file_uri.replace(
            "https://blobstoragefors3bucket.blob.core.windows.net",
            ""
          ),
        });

    if (arr.length - 1 === i) {
      policyItems.push({ label: prevDept, key: prevDept, children: children });
      prevDept = val.department;
    }

    return null;
  });

  return policyItems;
};

export const arrayToOptions = (arr) => {
  if (!arr || !Array.isArray(arr)) {
    return [];
  }
  let options = arr.map((val) => ({ label: val, value: val }));

  options.sort((a, b) => {
    let fa = String(a.value ?? "").toLowerCase(),
      fb = String(b.value ?? "").toLowerCase();

    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    return 0;
  });
  return options;
};

export const checkPleaseLogin = async (navigate) => {
  const data = await GetDropDownApi("");

  if (data.data.message === "Please Login.") {
    navigate("/auth");
    return true;
  }
  return false;
};

export function downloadBlob(blob, name = "Download") {
  const file = new Blob([blob], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(file);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = name;
  anchor.click();
  anchor.remove();
}

export function downloadBlobHtml(blob1, name = "Download") {
  const blob = new Blob([blob1], { type: "text/html" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}.html`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
